import { DigitalWalletConfiguration } from "./DigitalWalletConfiguration";

export interface Provider {
    vendor: string;
    versions: string[];
}

// One configurable integration a payment vendor exposes + the payment concept it serves. Discovered via
// providerConfigurationApi.listIntegrations so the payment editor can offer an integration picker.
export interface Integration {
    key: string;
    concept: string;       // "card-not-present" / "card-present" / "gift"
    displayName: string;
}

export interface ProviderConfiguration {
    locationId?: string;
    externalId: string;
    kind: number;
    vendor: string;
    version: string;
    configurationJson: string;
}



export const PaymentMethodsAccepted = {
    Visa: 1,
    Mastercard: 2,
    Amex: 4,
    Discover: 8,
    RoomCharge: 16,
    Diners: 32,
    JCB: 64,
    GiftCard: 128,
    Cash: 256,
} as const;

// One integration's config within a location's payment configuration (vendor/methods/wallet are shared).
export interface PaymentIntegrationConfig {
    integrationType: string;
    version: string;
    configurationJson: string;
    // Whether this integration is turned on for the location. Enabled integrations enforce their required
    // fields (readiness) and appear in client onboarding; disabled ones do neither. Defaults to true.
    enabled: boolean;
}

// Payment vendors have no external/site id — omit externalId from the base contract.
export interface PaymentProviderConfiguration extends Omit<ProviderConfiguration, 'externalId'> {
    // Which of the vendor's integrations this config targets (e.g. "hosted-payment-page", "afcc"); empty/undefined
    // => the vendor's default (card-not-present). Legacy single field — mirrors integrationConfigurations[0].
    integrationType?: string;
    paymentMethodsAccepted: number;
    allowGiftCardTipping: boolean;
    digitalWalletConfiguration: DigitalWalletConfiguration | undefined;
    // One entry per integration the vendor exposes, each with its own config JSON (vendor/methods/wallet above
    // are shared). Edited as an accordion per integration; persisted per-integration on save.
    integrationConfigurations?: PaymentIntegrationConfig[];
}

//export interface PmsProviderConfiguration extends ProviderConfiguration {
//}

export interface LoyaltyProviderConfiguration extends ProviderConfiguration {
}

// TouchTab feedback is a vendor now, chosen via `vendor` like Akira or Tattle - there is no separate
// per-location toggle. The brand-level entitlement is a different flag and lives on Brand.
export interface FeedbackProviderConfiguration extends ProviderConfiguration {
    // Google review prompting. These live on the feedback configuration row itself rather than in the
    // vendor's config JSON, so they apply whichever vendor is selected. They were on the API long before
    // anything in the portal could set them (TTD-166).
    googleReviewEnabled: boolean;
    googlePlaceId?: string | null;
}

export interface EmptyProviderConfiguration {
    configurationJson: string;
}